<div
  cdkOverlayOrigin
  class="ant-select-selection"
  [class.ant-select-selection--single]="isSingleMode"
  [class.ant-select-selection--multiple]="isMultipleOrTags"
  (keydown)="onKeyDownCdkOverlayOrigin($event)"
  tabindex="0">
  <div
    dw-select-top-control
    [dwOpen]="dwOpen"
    [compareWith]="compareWith"
    [dwPlaceHolder]="dwPlaceHolder"
    [dwShowSearch]="dwShowSearch"
    [dwDisabled]="dwDisabled"
    [dwMode]="dwMode"
    [dwListTemplateOfOption]="listOfTemplateOption"
    [dwListOfSelectedValue]="listOfSelectedValue"
    (dwOnSearch)="onSearch($event.value,$event.emit)"
    (dwListOfSelectedValueChange)="updateListOfSelectedValueFromTopControl($event)">
  </div>
  <span *ngIf="dwAllowClear" class="ant-select-selection__clear" dw-select-unselectable (click)="onClearSelection($event)"></span>
  <span class="ant-select-arrow" dw-select-unselectable><b></b></span>
</div>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayOrigin]="cdkOverlayOrigin"
  (backdropClick)="closeDropDown()"
  (detach)="closeDropDown();"
  (positionChange)="onPositionChange($event)"
  [cdkConnectedOverlayWidth]="overlayWidth"
  [cdkConnectedOverlayMinWidth]="overlayMinWidth"
  [cdkConnectedOverlayOpen]="!isDestroy">
  <div [ngClass]="dropDownClassMap" [@dropDownAnimation]="dwOpen ? dropDownPosition : 'hidden' " [ngStyle]="dwDropdownStyle">
    <div
      style="overflow: auto"
      dw-option-container
      [listOfDwOptionComponent]="listOfDwOptionComponent"
      [listOfDwOptionGroupComponent]="listOfDwOptionGroupComponent"
      [dwSearchValue]="searchValue"
      [dwFilterOption]="dwFilterOption"
      [dwServerSearch]="dwServerSearch"
      [compareWith]="compareWith"
      [dwNotFoundContent]="dwNotFoundContent"
      [dwMaxMultipleCount]="dwMaxMultipleCount"
      [dwMode]="dwMode"
      (dwScrollToBottom)="dwScrollToBottom.emit()"
      (dwClickOption)="onClickOptionFromOptionContainer()"
      (dwListOfTemplateOptionChange)="listOfTemplateOptionChange($event)"
      (dwListOfSelectedValueChange)="updateListOfSelectedValueFromOptionContainer($event)"
      [dwListOfSelectedValue]="listOfSelectedValue">
    </div>
  </div>
</ng-template>
<!--can not use ViewChild since it will match sub options in option group -->
<ng-template>
  <ng-content></ng-content>
</ng-template>